import React, {useEffect, useState} from 'react'
import EventBoothManager from "virtual_congress/booth_editor/event_booth_manager";
import Settings from "virtual_congress/booth_editor/components/settings"
import logoImage from "flave/flave_logo_transparent_hellerbg_cut.png"
import uegLogo from "custom/flaveueg22/logo.jpg"
import flaveLogo from "flave/flave_logo_transparent_claim_hellerBG.png"
import {matchPath} from 'react-router';
import Select from 'react-select';
import RenderedHtmlContent from "src/shared/virtual_congress/components/rendered_html_content";

import {
  Switch,
  Route,
  Link,
  useLocation,
  useHistory,
} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import CustomCss from "virtual_congress/components/custom_css";
import SupportChat from "../../booth_editor/components/support_chat/support_chat";
import Contacts from "../../booth_editor/components/contacts";
import Leads from "../../booth_editor/components/leads";
import Tracking from "../../booth_editor/components/tracking";
import Meetings from "../../booth_editor/components/meetings";
import Accounts from "../../booth_editor/components/accounts";
import IframeResizer from "iframe-resizer-react";
import SimpleDashboard from "../../../../custom/flaveueg22/exhibition/components/simple_dashboard/simple_dashboard";
import {applyAccountOrganizationChanges} from "../../actions";
//import SupportChat from "virtual_congress/components/modals/support_chat";
// import SupportChat from "virtual_congress/booth_editor/components/support_chat";

const UegSimpleDashboardEditor = ({imageMap, accountOrganization}) => {
  const dispatch = useDispatch()
  const [showPreview, setShowPreview] = useState()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [hasChangedFormData, setHasChangedFormData] = useState(false)
  const history = useHistory()
  const onPreviewChange = (event) => {
    const confirmSwitchPreviewWithChangesText = "Your changes will be lost if you switch to preview mode. Are you sure you want to switch?";
    if (showPreview || (!hasChangedFormData || confirm(confirmSwitchPreviewWithChangesText))) {
      setHasChangedFormData(false)
      setShowPreview(!showPreview);
    }
  }

  const onClickSave = () => {
    console.log("ABC", window.submitSimpleDashboardForm)
    if (window.submitSimpleDashboardForm) {
      window.submitSimpleDashboardForm()
    } else {
      alert("Error")
    }
  }

  useEffect(() => {
    window.applyAccountOrganizationChanges = (accountOrganization) => {
      dispatch(applyAccountOrganizationChanges(accountOrganization))
    }
    window.switchToContacts = () => {
      history.replace("/contacts");
    }
    window.switchToMeetings = () => {
      history.replace("/meetings");
    }
    window.submittingDone = () => {
      setIsSubmitting(false)
    }
    window.isSubmitting = () => {
      setIsSubmitting(true)
    }
    window.setHasChangedFormData = (hasChangedFormData) => {
      setHasChangedFormData(hasChangedFormData)
    }
  }, [dispatch, history, setIsSubmitting, setHasChangedFormData])

  useEffect(() => {
    if (showPreview) {
      window.submitSimpleDashboardForm = null
    }
  }, [showPreview])


  return <>
    <div className="row justify-content-center badge-colored sticky-top mt-2">
      <div className="col-10 py-2 text-right">
        <div className="custom-control custom-switch d-inline-block mr-4">
          <input type="checkbox" className="custom-control-input" id="customSwitch1" checked={showPreview} onChange={onPreviewChange}/>
          <label className="custom-control-label" htmlFor="customSwitch1">Preview</label>
        </div>

        {!showPreview && <button
          type={"button"}
          onClick={onClickSave}
          className="btn btn-sm btn-ueg btn-ueg-styled"
          disabled={isSubmitting}
          style={{color: "white", borderColor: "white"}}>
          {isSubmitting ? <>
            <i className="fas fa-circle-notch fa-spin"></i> Saving ...
          </> : <>
            <i className="fa fa-save fa-fw"/> Save
          </>}
        </button>}
      </div>
    </div>
    {showPreview ? <SimpleDashboard accountOrganization={accountOrganization} isPreview={true}/> : <IframeResizer
      log
      src={`/account_organizations/backends?account_organization_id=${imageMap.account_organization_id}`}
      style={{width: '1px', minWidth: '100%'}}
      frameBorder="0"
    />}
  </>
}

const RenderedEventBoothManager = () => {
  const hostname = useSelector(state => state.hostname)
  const imageMap = useSelector(state => state.imageMap)
  //const normalImageMaps = useSelector(state => state.normalImageMaps)
  const accountOrganization = useSelector((state) => state.accountOrganization)

  //if (["flaveueg21", "flaveueg22", "flaveueg23"].includes(hostname) && !normalImageMaps.includes(accountOrganization.external_id)) {
  //  return <UegSimpleDashboardEditor imageMap={imageMap} accountOrganization={accountOrganization}/>
  //}

  return <EventBoothManager/>
}

export default function Navigation() {
  const account = useSelector((state) => state.account)
  const accountOrganization = useSelector((state) => state.accountOrganization)
  const logoutUrl = useSelector((state) => state.logoutUrl)
  const location = useLocation()
  const imageMaps = useSelector(state => state.imageMaps)
  const imageMap = useSelector(state => state.imageMap)
  const isNewBoothEditor = useSelector(state => state.isNewBoothEditor)
  const hostname = useSelector(state => state.hostname)

  const isSupportChatOnly = account.category && account.category.trim() === "support_chat_only"

  const boothPath = `/booth`
  const isBoothActive = !!matchPath(
    location.pathname,
    boothPath
  );

  const trackingPath = `/tracking`
  const isTrackingActive = !!matchPath(
    location.pathname,
    trackingPath
  );

  const settingsPath = `/settings`
  const isSettingsActive = !!matchPath(
    location.pathname,
    settingsPath
  );

  const notificationPath = `/notification`
  const isNotificationActive = !!matchPath(
    location.pathname,
    notificationPath
  );

  const supportChatPath = `/chat`
  const isSupportChatActive = !!matchPath(
    location.pathname,
    supportChatPath
  );

  const contactsPath = `/contacts`
  const isContactsActive = !!matchPath(
    location.pathname,
    contactsPath
  );

  const leadsPath = `/leads`
  const isLeadsActive = !!matchPath(
    location.pathname,
    leadsPath
  );

  const meetingsPath = `/meetings`
  const isMeetingsActive = !!matchPath(
    location.pathname,
    leadsPath
  );

  const accountsPath = `/accounts`
  const isAccountsActive = !!matchPath(
    location.pathname,
    accountsPath
  );

  return <div className="row no-gutters">
    <style>
      {`.preview-modal {
        position: absolute;
      }
      .booth-editor-image-map-select__menu {
        z-index: 9999999
      }
      `}
    </style>
    <CustomCss accountOrganization={accountOrganization}/>
    <div className="col-12">
      <div className="row no-gutters justify-content-center navigation-row d-none d-md-flex d-lg-flex d-xl-flex">
        <div className="col-12 d-flex align-items-center">

          <Link to="/" className="my-2 mr-auto">
            <img src={logoImage} className="img-fluid navigation-logo"/>
          </Link>

          <span className={"text-muted"}>
            {account?.name}
          </span>

          <a className="btn mr-3" rel="nofollow" data-method="delete" href={logoutUrl}>
            Sign out
            <i className="fa fa-sign-out-alt m-1"/>
          </a>
        </div>
      </div>
      <div className="row no-gutters justify-content-center navigation-row">
        <div className="col-12">
          <nav className="navbar navbar-expand-md navbar-light">
            <Link to="/" className="navbar-brand d-inline-block d-md-none d-lg-none d-xl-none">
              <img src={logoImage} className="navigation-logo"/>
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
              style={{marginRight: "1rem"}}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav">
                {!isSupportChatOnly && <>
                  {/*<li className={"nav-item" + (isTrackingActive ? " active" : "")}>*/}
                  {/*  <Link to={trackingPath} className="nav-link">*/}
                  {/*    Tracking*/}
                  {/*  </Link>*/}
                  {/*</li>*/}
                  <li className={"nav-item" + (isBoothActive ? " active" : "")}>
                    <Link to={boothPath} className="nav-link">
                      {(hostname === "flaveueg22" || hostname === "flaveueg23") ? <>
                        Company Profile
                      </> : <>
                        Booth
                      </>}
                    </Link>
                  </li>
                  <li className={"nav-item" + (isSettingsActive ? " active" : "")}>
                    <Link to={settingsPath} className="nav-link">
                      Settings
                    </Link>
                  </li>
                  {["flaveueg21"].includes(hostname) &&
                    <li className={"nav-item" + (isNotificationActive ? " active" : "")}>
                      <Link to={notificationPath} className="nav-link">
                        Notifications
                      </Link>
                    </li>}
                  {accountOrganization.virtual_congress_chat_permission &&
                    <li className={"nav-item" + (isSupportChatActive ? " active" : "")}>
                      <Link to={supportChatPath} className="nav-link">
                        Chat
                      </Link>
                    </li>}
                  {accountOrganization.virtual_congress_contact_permission &&
                    <li className={"nav-item" + (isContactsActive ? " active" : "")}>
                      <Link to={contactsPath} className="nav-link">
                        Contacts
                      </Link>
                    </li>}
                  {accountOrganization.virtual_congress_allow_leads_permission &&
                    <li className={"nav-item" + (isLeadsActive ? " active" : "")}>
                      <Link to={leadsPath} className="nav-link">
                        Leads
                      </Link>
                    </li>}
                  {accountOrganization.virtual_congress_tracking_permission &&
                    <li className={"nav-item" + (isTrackingActive ? " active" : "")}>
                      <Link to={trackingPath} className="nav-link">
                        Tracking
                      </Link>
                    </li>}
                  {accountOrganization.virtual_congress_meetings_permission &&
                    <li className={"nav-item" + (isMeetingsActive ? " active" : "")}>
                      <Link to={meetingsPath} className="nav-link">
                        Meetings
                      </Link>
                    </li>}
                  {accountOrganization.virtual_congress_accounts_permission &&
                    <li className={"nav-item" + (isAccountsActive ? " active" : "")}>
                      <Link to={accountsPath} className="nav-link">
                        User
                      </Link>
                    </li>}
                </>}
                <li className="nav-item d-inline-block d-md-none d-lg-none d-xl-none">
                  <a className="nav-link" rel="nofollow" data-method="delete" href={logoutUrl}>
                    Sign out
                    <i className="fa fa-sign-out-alt m-1"/>
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
      {imageMaps.length > 1 && matchPath(location.pathname, "/booth") &&
        <div className="row mt-2">
          <div className="col-12 pl-4 pr-4">
            {/*
          <nav className="navbar navbar-expand-md navbar-light">
            <ul className="navbar-nav">
              {imageMaps.map((imgMap) => { return (
                <li key={"imgmap" + imgMap.id} className={"nav-item" + (imgMap.id == imageMap.id ? " active" : "")}>
                  <a className="nav-link" style={{fontSize: "0.8em", textAlign: "center"}} href={isNewBoothEditor ? `/event_booth/image_maps/${imgMap.id}/edit#/booth` : `/event_booth/${imgMap.id}/edit#/booth`}>{imgMap.title != "" ? imgMap.title : imgMap.id}</a>
                </li>
              )})}
            </ul>


          </nav>
          */}
            <Select
              classNamePrefix="booth-editor-image-map-select"
              defaultValue={{
                label: "#" + imageMap.id + " - " + imageMap.title + (imageMap.identifier && imageMap.identifier != "" ? " (identifier: " + imageMap.identifier + ")" : ""),
                value: imageMap.id
              }}
              options={imageMaps.map(imgMap => {
                return {
                  label: "#" + imgMap.id + " - " + imgMap.title + (imgMap.identifier && imgMap.identifier != "" ? " (identifier: " + imgMap.identifier + ")" : ""),
                  value: imgMap.id
                }
              })}
              onChange={(imgMap) => {
                console.log("onchange", imgMap)
                window.location = `/event_booth/image_maps/${imgMap.value}/edit#/booth`
              }}>

            </Select>
          </div>
        </div>
      }
    </div>
    <div className="col-12">
      <Switch>
        {!isSupportChatOnly && <>
          <Route path={boothPath}>
            <RenderedEventBoothManager/>
          </Route>
          <Route path={settingsPath}>
            <Settings/>
          </Route>
          <Route path={notificationPath}>
            Notification
          </Route>
          {accountOrganization.virtual_congress_chat_permission && <Route path={supportChatPath}>
            <SupportChat/>
          </Route>}
          {accountOrganization.virtual_congress_contact_permission && <Route path={contactsPath}>
            <Contacts/>
          </Route>}
          {accountOrganization.virtual_congress_allow_leads_permission && <Route path={leadsPath}>
            <Leads/>
          </Route>}
          {accountOrganization.virtual_congress_tracking_permission && <Route path={trackingPath}>
            <Tracking/>
          </Route>}
          {accountOrganization.virtual_congress_meetings_permission && <Route path={meetingsPath}>
            <Meetings/>
          </Route>}
          {accountOrganization.virtual_congress_accounts_permission && <Route path={accountsPath}>
            <Accounts/>
          </Route>}

          <Route exact path="/">
            <div className="row">
              <div className="col-12 text-center">
                {(hostname === "flaveueg22" || hostname === "flaveueg23") && <div className="text-center">
                  <img src={uegLogo} alt="" style={{width: "100px", marginTop: "15px", marginBottom: "10px"}}/>
                  <h3>{accountOrganization.title}</h3>
                  <hr/>
                </div>}

                <h1>Welcome to your booth management</h1>
                <p>
                  Here you'll find all you need to manage your virtual booth.

                  {(hostname === "flaveueg22" || hostname === "flaveueg23") ? <>
                    To set up your page you can click
                    <Link to={boothPath}> here.</Link>
                  </> : <>
                    To set up your boot click Booth in the menu.
                  </>}
                </p>

                {(hostname === "flaveueg22" || hostname === "flaveueg23") && <div className="text-center">
                  <hr/>
                  <img src={flaveLogo} alt="" style={{width: "150px", marginTop: "15px"}}/>
                </div>}
              </div>
            </div>
          </Route>
        </>}

        {isSupportChatOnly && <Route path="/">
          <SupportChat/>
        </Route>}
      </Switch>
    </div>
    <RenderedHtmlContent identifier="event_booth.css_fixes"/>
  </div>
}
